export default __webpack_public_path__ + "static/media/home-12.c0bc6cda.jpg";